"use client";

import { ArrowRight, Fingerprint, Gavel, PenTool, Repeat, Shield, Building2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Consultancyservicesgrid() {
  const services = [{
    number: "SERVICE 01 — SEO",
    title: "National SEO Strategy.",
    description: "I build authority for UK-wide brands. I focus on sustainable growth, technical health, and content that ranks for high-intent search terms.",
    tags: ["Authority", "Strategy", "Growth"],
    icon: Fingerprint
  }, {
    number: "SERVICE 02 — GLOBAL",
    title: "International SEO.",
    description: "I help you scale across borders. I manage hreflang, regional targeting, and cultural search nuances to ensure your site performs globally.",
    tags: ["Global", "Hreflang", "Scale"],
    icon: PenTool
  }, {
    number: "SERVICE 03 — LOCAL",
    title: "Local SEO Expertise.",
    description: "I dominate local search results. I optimise your Google Business Profile and local citations to drive footfall and regional enquiries.",
    tags: ["Maps", "Citations", "Local"],
    icon: Shield
  }, {
    number: "SERVICE 04 — B2B",
    title: "B2B SEO & Lead Gen.",
    description: "I turn search into revenue. I focus on high-value B2B keywords and conversion paths that attract decision-makers to your business.",
    tags: ["Leads", "B2B", "Revenue"],
    icon: Repeat
  }, {
    number: "SERVICE 05 — ECOM",
    title: "Ecommerce SEO.",
    description: "I optimise your product visibility. I handle site architecture, schema, and category performance to increase your online sales.",
    tags: ["Products", "Schema", "Sales"],
    icon: Building2
  }, {
    number: "SERVICE 06 — TECH",
    title: "Technical SEO Audits.",
    description: "I fix the foundation. I perform deep-dive audits to resolve crawl issues, speed bottlenecks, and indexing errors holding you back.",
    tags: ["Audits", "Speed", "Crawl"],
    icon: Gavel
  }];
  return <section data-section-id="23134" id="consultancyservicesgrid" data-nav="light" className="bg-background py-[clamp(6rem,10vw,10rem)]">
      <div className="mx-auto max-w-[1440px] px-[clamp(1.5rem,4vw,4.5rem)]">
        {}
        <div className="h-px w-full bg-border" />

        {}
        <div className="mt-16 grid grid-cols-1 gap-8 md:grid-cols-12 md:gap-8">
          <div className="md:col-span-3">
            <span className="font-sans text-xs font-medium uppercase text-muted-foreground" style={{
            letterSpacing: "0.16em"
          }}>
              MY SERVICES — 06
            </span>
          </div>

          <div className="md:col-span-9">
            <h2 className="font-serif text-foreground" style={{
            fontSize: "clamp(1.8125rem, 2.8vw, 2.375rem)",
            lineHeight: "0.98",
            letterSpacing: "-0.028em",
            fontWeight: 400
          }}>
              Six ways{" "}
              <br className="hidden sm:block" />
              we can work{" "}
              <br className="hidden sm:block" />
              <span className="relative inline-block italic">
                <span className="relative z-10">together</span>
                <svg aria-hidden="true" className="absolute left-0 right-0 -bottom-2 w-full" viewBox="0 0 300 18" preserveAspectRatio="none" style={{
                height: "0.4em"
              }}>
                  <path d="M2,12 C60,4 120,15 180,8 C220,4 260,12 298,7" stroke="hsl(340 75% 65%)" strokeWidth="8" strokeLinecap="round" fill="none" opacity="0.55" />
                </svg>
              </span>
              <span className="text-foreground">.</span>
            </h2>

            <p className="mt-12 max-w-2xl font-sans text-foreground" style={{
            fontSize: "clamp(1.25rem, 1.55vw, 1.5rem)",
            lineHeight: "1.55",
            letterSpacing: "-0.005em"
          }}>
              Choose one, or combine several — I tailor my SEO strategy to your 
              specific business goals and growth requirements.
            </p>

            <div className="mt-10">
              <Button asChild variant="outline" className="h-14 rounded-lg border-[1.5px] border-primary bg-transparent px-8 text-primary hover:bg-primary hover:text-primary-foreground">
                <Link to="/ContactPage">
                  <span className="font-sans text-[17px] font-medium">
                    Book a Free SEO Consultation
                  </span>
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
            </div>
          </div>
        </div>

        {}
        <div className="mt-24 grid grid-cols-1 gap-8 md:grid-cols-2">
          {services.map((service, i) => {
          const isNavy = i % 2 === 1;
          const Icon = service.icon;
          return <article key={i} data-index={i} className={["group relative flex flex-col p-[clamp(1.75rem,2.5vw,2.75rem)]", "rounded-3xl transition-all duration-300", isNavy ? "bg-primary text-primary-foreground" : "bg-card text-card-foreground"].join(" ")}>
                <div className="transition-transform duration-300 ease-out group-hover:-translate-y-1">
                  {}
                  <Icon className={["h-6 w-6", isNavy ? "text-primary-foreground" : "text-primary"].join(" ")} strokeWidth={1.25} />

                  {}
                  <div className="mt-6">
                    <span className={["font-sans text-xs font-medium uppercase", isNavy ? "text-primary-foreground/70" : "text-muted-foreground"].join(" ")} style={{
                  letterSpacing: "0.16em"
                }}>
                      {service.number}
                    </span>
                  </div>

                  {}
                  <h3 className={["mt-5 font-serif", isNavy ? "text-primary-foreground" : "text-foreground"].join(" ")} style={{
                fontSize: "clamp(1.4375rem, 1.8vw, 1.625rem)",
                lineHeight: "1.08",
                letterSpacing: "-0.02em",
                fontWeight: 400
              }}>
                    {service.title}
                  </h3>
                  <div className={["mt-3 h-px w-0 transition-all duration-500 ease-out group-hover:w-16", "bg-accent"].join(" ")} />

                  {}
                  <p className={["mt-5 font-sans", isNavy ? "text-primary-foreground/85" : "text-foreground/80"].join(" ")} style={{
                fontSize: "clamp(1.0625rem, 1.15vw, 1.1875rem)",
                lineHeight: "1.6"
              }}>
                    {service.description}
                  </p>

                  {}
                  <div className="mt-8 flex flex-wrap gap-2">
                    {service.tags.map((tag, j) => <span key={j} data-index={j} className={["inline-flex items-center rounded-full border px-4 py-2 font-sans text-xs font-medium uppercase", isNavy ? "border-primary-foreground/40 text-primary-foreground" : "border-primary/20 text-primary"].join(" ")} style={{
                  letterSpacing: "0.16em"
                }}>
                        {tag}
                      </span>)}
                  </div>

                  {}
                  <div className="mt-10">
                    <Link to="/ServicesPage" className={["group/link relative inline-flex items-center gap-2 font-sans text-[17px] font-medium", isNavy ? "text-primary-foreground" : "text-primary"].join(" ")}>
                      <span className="relative">
                        Learn more
                        <span className="absolute -bottom-1 left-0 h-0.5 w-0 bg-accent transition-all duration-300 ease-out group-hover/link:w-full" />
                      </span>
                      <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover/link:translate-x-1" />
                    </Link>
                  </div>
                </div>
              </article>;
        })}
        </div>
      </div>
    </section>;
}